import { Box, IconButton, Typography } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { convertByteString } from '../utils/utils';

type Props = {
    file?: File;
    imageId?: string;
    onDeleteUploadFile: (file?: File) => void;
}

const FileUploadPreview = ({ file, imageId, onDeleteUploadFile }: Props) => {

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                border: (theme) => `solid 1px ${theme.palette.divider}`,
                borderRadius: 2.5,
                p: 2,
            }}
        >
            <Box sx={{ mr: 3, width: "20px", display: "flex" }}>
                <ImageOutlinedIcon />
            </Box>
            <Box sx={{ flex: 1, fontSize: 14, width: "calc(100% - 70px)" }}>
                <Typography sx={{
                    fontSize: 14,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '1',
                    WebkitBoxOrient: 'vertical'
                }}>{file ? file.name : "id: " + imageId}</Typography>
                <Box
                    component="span"
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    {file ? convertByteString(file.size) : ""}
                </Box>
            </Box>
            <IconButton
                sx={{
                    padding: 1.5,
                    fontSize: 16,
                    ml: 1
                }}
                onClick={() => onDeleteUploadFile(file)}
            >
                <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
        </Box>
    );
};

export default FileUploadPreview;
